<template>
  <setting-scout-template-form
    @submit="register"
  />
</template>

<script>
import SettingScoutTemplateForm from '@/components/organisms/SettingScoutTemplateForm'
import Indicator from '@/lib/indicator'

export default {
  components: {
    SettingScoutTemplateForm
  },
  methods: {
    register (message) {
      Indicator.emitShow()
      this.$http.secured.post('/company/scout/message/templates', message).then(response => {
        this.$router.push({ name: 'settingScoutTemplates' })
      }).finally(() => {
        Indicator.emitHide()
      })
    }
  }
}
</script>
